import icon1 from '../assets/icons/Icon1.svg'
import icon2 from '../assets/icons/Icon2.svg'
import icon3 from '../assets/icons/Icon3.svg'
import icon4 from '../assets/icons/Icon4.svg'

export const cardsData = [
    {
        id: 1,
        strong: "Materia prima de calidad",
        highlight: "internacional, con certificaciones y respaldo BASF.",
        image: icon1,
        size: "w-11 h-11",
        padding: "px-6 md:px-7 xl:px-14",
    },
    {
        id: 2,
        strong: "Relación directa,",
        highlight: "sin distribuidores",
        image: icon2,
        size: "w-14 h-11",
        padding: "px-12 md:px-14 xl:px-20",
    },
    {
        id: 3,
        strong: "Consultoría técnica",
        highlight: "sin cargo para mejorar tus formulaciones",
        image: icon3,
        size: "w-11 h-11",
        padding: "px-[2rem] md:px-[2.95rem]",
    },
    {
        id: 4,
        strong: "Acceso prioritario a capacitaciones,",
        highlight: "exposiciones y fichas técnicas",
        image: icon4,
        size: "w-11 h-11",
        padding: "px-2 md:px-5",
    },            
];